import * as yup from 'yup';

export const insuredObjectBaseSchema = yup.object({
  bewohnt: yup.boolean().default(false),
  gefahrerheblicheUmstaende: yup.object({
    vorhanden: yup.boolean().default(false),
    memofeld: yup
      .string()
      .default('')
      .when('vorhanden', {
        is: (val: boolean) => val,
        then: yup.string().required(),
      }),
  }),
});
